import { h } from 'preact';
import Page from 'components/pages/page.js';
// import { Link } from 'components/core/link/link.js';
import * as transitionStates from 'components/core/transition/transitionStates.js';
import pure from 'utils/pure';
import { useDynamicAssetFolder, IMAGE_REGION_ROOT_DYNAMIC } from 'utils/assets';
import s from 'components/pages/synopsis/synopsis.sss';
import HTML from 'components/core/html/html';
import { marked } from 'marked';

import { getSizeBasedTT } from 'utils/clientUtils';

marked.setOptions({
	breaks: true,
	smartLists: true
});

export default @pure class Synopsis extends Page {

	render({ appData, pageData, transitionState }) {
		const { copy } = appData;
		const { imageSrc, disableSynopsisHeader } = pageData;

		let contentClass = s.contentBox;

		const description = pageData.descriptionCopy ? copy[pageData.descriptionCopy] : copy.$SYNOPSIS_DESCRIPTION;
		const headerCopy = pageData.headerCopy ? copy[pageData.headerCopy] : copy.$SYNOPSIS_HEADER;
		const cast = pageData.castContent ? pageData.castContent : copy.$SYNOPSIS_CAST;
		const descriptionHeader = pageData.descriptionHeader ? pageData.descriptionHeader : copy.$SYNOPSIS;
		const date = pageData.synopsisDate ? pageData.synopsisDate : copy.$SYNOPSIS_DATE;

		let languageDirection = appData.meta.region.slug === 'il';

		if (transitionState === transitionStates.STATE_CHILD_ENTERING || transitionState === transitionStates.STATE_CHILD_LEAVING) {
			contentClass = s.contentBoxTransition;
		}

		//!!!!!WARNING!!!!! If you want to do custom styling on the synopsis page,
		// use the s.customContainer class as a wrapper if your override!!!!
		let contentContainer = pageData.customStyling || pageData.includeCast ? s.customContainer : s.contentContainer;

		let paragraphs;
		if (pageData.includeCast) {
			paragraphs = [
				<HTML class={s.castDescription} content={description} markdown />,
				<HTML class={s.castContent} content={cast} markdown />
			];
		} else {
			let header;
			if (!imageSrc && !disableSynopsisHeader) {
				header = <h1 class={s.synopsisHeader}>{descriptionHeader}</h1>;
			}
			paragraphs = (
				<div class={s.description}>
					{header}
					<HTML content={description} markdown />
				</div>
			);
		}

		return (
			<div class={contentClass}>
				<div class={contentContainer}>
					{this.getTitleTreatment()}
					<HTML class={s.header} content={headerCopy} markdown />
					<HTML class={s.synopsisDate} content={date} markdown />
					<bdo class={s.paragraphs} dir={languageDirection ? 'rtl' : 'ltr'}>
						{paragraphs}
					</bdo>
					{this.getExtraContent()}
				</div>
				<div class={s.contentOutside}>{this.getContentOutside()}</div>
			</div>
		);

	}

	getTitleTreatment() {
		let pageData = this.props.pageData;
		let imgRoot = IMAGE_REGION_ROOT_DYNAMIC;
		const { copy } = this.props.appData;
		let baseName = pageData.includeCast ? pageData.imageSrcCast || pageData.imageSrc : pageData.imageSrc;
		let src = useDynamicAssetFolder(baseName);
		const alt = pageData.altTitle ? pageData.altTitle : (copy.$SYNOPSIS_ALT_TITLE || copy.$TITLE);

		if (pageData.imageSrcAlternate) {
			// let alternateName = pageData.imageSrcAlternate || imgRoot + '/tt2.png';
			src = getSizeBasedTT(pageData.imageSrcAlternate, this.props.client, baseName);
			if (src && !src.match(/^(https?:)?\/\//)) {
				src = useDynamicAssetFolder(imgRoot + '/' + src);
			}
		}
		if (!src) {
			return;
		}

		return <img alt={alt} class={s.title} src={src} key="tt" />;
	}

	getExtraContent() {}

	getContentOutside() {}
}

export const verticallyCenter = true;
